import { LOCALE_ID, NgModule } from "@angular/core"
import { BrowserModule } from "@angular/platform-browser"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { InputTextModule } from "primeng/inputtext"
import { ReactiveFormsModule } from "@angular/forms"
import { DropdownModule } from "primeng/dropdown"
import { CalendarModule } from "primeng/calendar"
import { RadioButtonModule } from "primeng/radiobutton"
import { CheckboxModule } from "primeng/checkbox"
import { Routes, RouterModule } from "@angular/router"
import { StepsModule } from "primeng/steps"
import { CardModule } from "primeng/card"
import { HttpClientModule } from "@angular/common/http"
import { AppComponent } from "./app.component"
import { DataFormComponent } from "./components/data-form/data-form.component"
import { AvailabilityCheckComponent } from "./components/availability-check/availability-check.component"
import { ProductOptionsComponent } from "./components/product-options/product-options.component"
import { OrderStepsComponent } from "./components/order-steps/order-steps.component"
import { OrderSummaryComponent } from "./components/order-summary/order-summary.component"
import { ShoppingBasketComponent } from "./components/shopping-basket/shopping-basket.component"
import { ButtonModule } from "primeng/button"
import { ValidationMarkComponent } from "./components/validation-mark/validation-mark.component"
import { AvailabilityCheckResultComponent } from "./components/availability-check-result/availability-check-result.component"
import { MessagesModule } from "primeng/messages"
import { BaseProductComponent } from "./components/base-product/base-product.component"
import { DividerModule } from "primeng/divider"
import { BlockUIModule } from "primeng/blockui"
import { ProductOptionComponent } from "./components/product-option/product-option.component"
import { CustomerDataFormComponent } from "./components/customer-data-form/customer-data-form.component"
import { BillingAddressFormComponent } from "./components/billing-address-form/billing-address-form.component"
import { BankingAccountFormComponent } from "./components/banking-account-form/banking-account-form.component"
import { PortingFormComponent } from "./components/porting-form/porting-form.component"
import { ToastModule } from "primeng/toast"
import { MessageService } from "primeng/api"
import { registerLocaleData } from "@angular/common"
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { HotlineCtaComponent } from './components/hotline-cta/hotline-cta.component';
import { CanActivateGuard } from "./tools/can-activate.guard"
import { PhoneBookFormComponent } from "./components/phone-book-form/phone-book-form.component";
import { PhoneBookEntryComponent } from './components/phone-book-entry/phone-book-entry.component';
import { FooterComponent } from './components/footer/footer.component'
import { CustomerPromoFormComponent } from "./components/customer-promo-form/customer-promo-form.component"
import { TagModule } from 'primeng/tag';
import { BusinessDataFormComponent } from "./components/business-data-form/business-data-form.component"
import { ContactPersonFormComponent } from "./components/contact-person-form/contact-person-form.component"
import { BusinessBankingFormComponent } from "./components/business-banking-form/business-banking-form.component"
import { BusinessPortingFormComponent } from "./components/business-porting-form/business-porting-form.component"
import { HeaderComponent } from "./components/header/header.component"
import { OrderSummaryContactDataComponent } from "./components/order-summary/order-summary-contact-data.component"
import { OrderSummaryBusinessDataComponent } from "./components/order-summary/order-summary-business-data.component"
import { OrderSummaryContactPersonComponent } from "./components/order-summary/order-summary-contact-person.component"
import { OrderSummaryProductComponent } from "./components/order-summary/order-summary-product.component"
import { OrderSummaryBankingAccountComponent } from "./components/order-summary/order-summary-banking-account.component"
import { OrderSummaryBusinessBankingComponent } from "./components/order-summary/order-summary-business-banking.component"
import { OrderSummaryPortingComponent } from "./components/order-summary/order-summary-porting.component"
import { OrderSummaryBusinessPortingComponent } from "./components/order-summary/order-summary-business-porting.component"
import { OrderSummaryPhoneBookComponent } from "./components/order-summary/order-summary-phone-book.component"

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

const routes: Routes = [
  {
    path: "availability-check",
    component: AvailabilityCheckComponent,
    canActivate: [CanActivateGuard]
  },
  {
    path: "product-options",
    component: ProductOptionsComponent,
    canActivate: [CanActivateGuard]
  },
  {
    path: "data-form",
    component: DataFormComponent,
    canActivate: [CanActivateGuard]
  },
  {
    path: "order-summary",
    component: OrderSummaryComponent,
    canActivate: [CanActivateGuard]
  },
  {
    path: "**",
    redirectTo: "/availability-check",
    pathMatch: "full",
  }
]

@NgModule({
  declarations: [
    AppComponent,
    DataFormComponent,
    AvailabilityCheckComponent,
    ProductOptionsComponent,
    OrderStepsComponent,
    OrderSummaryComponent,
    ShoppingBasketComponent,
    ValidationMarkComponent,
    AvailabilityCheckResultComponent,
    BaseProductComponent,
    ProductOptionComponent,
    CustomerDataFormComponent,
    BillingAddressFormComponent,
    BankingAccountFormComponent,
    PortingFormComponent,
    HotlineCtaComponent,
    PhoneBookFormComponent,
    PhoneBookEntryComponent,
    FooterComponent,
    CustomerPromoFormComponent,
    BusinessDataFormComponent,
    ContactPersonFormComponent,
    BusinessBankingFormComponent,
    BusinessPortingFormComponent,
    HeaderComponent,
    OrderSummaryContactDataComponent,
    OrderSummaryBusinessDataComponent,
    OrderSummaryContactPersonComponent,
    OrderSummaryProductComponent,
    OrderSummaryBankingAccountComponent,
    OrderSummaryBusinessBankingComponent,
    OrderSummaryPortingComponent,
    OrderSummaryBusinessPortingComponent,
    OrderSummaryPhoneBookComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: "top", useHash: true }),
    InputTextModule,
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    RadioButtonModule,
    CheckboxModule,
    StepsModule,
    CardModule,
    HttpClientModule,
    ButtonModule,
    MessagesModule,
    DividerModule,
    BlockUIModule,
    ToastModule,
    TagModule
  ],
  providers: [MessageService, { provide: LOCALE_ID, useValue: 'de-DE' }],
  bootstrap: [AppComponent]
})
export class AppModule {}
